export default "__VITE_ASSET__1989ec34__"